import { useState } from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { useImpersonation } from "@/contexts/ImpersonationContext";
import { useNavigate } from "react-router-dom";
import { useToast } from "@/hooks/use-toast";
import { Eye, Search } from "lucide-react";

export function StudentSimulationCard() {
  const [formIvIndex, setFormIvIndex] = useState("");
  const [loading, setLoading] = useState(false);
  const { startStudentSimulation } = useImpersonation();
  const navigate = useNavigate();
  const { toast } = useToast();

  const handleSimulate = async () => {
    const trimmed = formIvIndex.trim();
    if (!trimmed) return;

    setLoading(true);
    const error = await startStudentSimulation(trimmed);
    setLoading(false);

    if (error) {
      toast({ title: "Student not found", description: error, variant: "destructive" });
    } else {
      toast({ title: "Simulation active", description: `Now viewing as student with index ${trimmed}` });
      navigate("/examination");
    }
  };

  return (
    <Card className="border-amber-200 bg-amber-50/50">
      <CardHeader className="pb-2">
        <CardTitle className="text-sm flex items-center gap-2">
          <Eye className="h-4 w-4 text-amber-600" />
          Simulate Student View
        </CardTitle>
        <CardDescription className="text-xs">
          Enter a Form IV index number to see the system as that student would (results, visibility gates, etc.)
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="flex gap-2">
          <div className="relative flex-1">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
            <Input
              placeholder="e.g. EQ.1234/0001/2024"
              className="pl-9"
              value={formIvIndex}
              onChange={(e) => setFormIvIndex(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && handleSimulate()}
            />
          </div>
          <Button
            onClick={handleSimulate}
            disabled={!formIvIndex.trim() || loading}
            size="sm"
            className="bg-amber-600 hover:bg-amber-700"
          >
            {loading ? "Looking up..." : "Simulate"}
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}
